export default "__VITE_ASSET__CZaZQ0gJ__"